import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { MembersOnlyWarningModalState, MembersOnlyWarningModalType } from './types';

const INITIAL_STATE: MembersOnlyWarningModalState = {
  visible: false,
};

const membersOnlyWarningModalSlice = createSlice({
  name: 'membersOnlyWarningModal',
  initialState: INITIAL_STATE,
  reducers: {
    dismissMembersOnlyWarningModalWithType: (state, { payload }: PayloadAction<MembersOnlyWarningModalType>) => {
      if (state.type === payload) {
        return {
          ...state,
          visible: false,
        };
      }
      return state;
    },
    setMembersOnlyWarningModalState: (
      state,
      { payload }: PayloadAction<Omit<MembersOnlyWarningModalState, 'visible'> | null>,
    ) => {
      return {
        ...state,
        ...(payload || undefined),
        visible: !!payload,
      };
    },
  },
});

export default membersOnlyWarningModalSlice;
